export enum QueryParamsFilterEnum {
  CITY_FILTER_NAME = 'city',
  RADIUS_FILTER_NAME = 'radius',
  START_DATE_FILTER_NAME = 'startDate',
  END_DATE_FILTER_NAME = 'endDate',
  SPORT_GROUPS_FILTER_NAME = 'sportGroups',
  PLACE_ID_FILTER_NAME = 'placeId',
}
